<template>
  <div class="booked-member">
    {{ data.member.user.name }}{{ data.enrollment_is_removed ? ' '+ '(삭제됨)' : '' }}
    <el-status-tag
      v-show="data.by_admin"
      label="지정"
    />

    <attendance-control-dropdown
      :key="data.member.id"
      style="padding: 9px 0px;"
      :data="data"
      :course-start="childCourse.start"
      :member-id="data.enrollment"
      :enrollment-option="true"
      @update="onAttendanceUpdate"
    />
  </div>
</template>

<script>
import ElStatusTag from './element-ui/ElStatusTag';
import AttendanceControlDropdown from './AttendanceControlDropdown';

export default {
  name: 'BookedMember',
  components: { AttendanceControlDropdown, ElStatusTag },
  props: {
    data: {},
    childCourse: {}
  },
  methods: {
    onAttendanceUpdate() {
      this.$emit('update', {});
    }
  }
};
</script>

<style lang="scss">
.booked-member {
  height: 50px;
  line-height: 48px;
  border-radius: 4px;
  border: 1px solid #d3d3d3;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 0 8px 0 15px;

  font-size: 15px;
  letter-spacing: -0.8px;
  color: #4a4a4a;

  .el-status-tag {
    margin-left: 10px;
  }

  .el-dropdown {
    float: right;
  }

  span.ic-more {
    width: 21px;
    height: 48px;
  }
}
</style>
